export default class CampaignBuyMoreModel {
    constructor() {
        this.campaignId = 0;
        this.minimumQuantity = 0;
        this.discountValue = 0;
    }
}
